import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from 'react-i18next';

interface StreakCardProps {
  days: number;
}

/**
 * Activity Streak Card Component
 * Displays consecutive days of activity with fire emoji
 */
export default function StreakCard({ days }: StreakCardProps) {
  const { t } = useTranslation();
  return (
    <Card className="bg-gradient-to-br from-orange-500 to-red-500 text-white border-0 card-hover glow-warning animate-fade-in">
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium opacity-90">{t('dashboard.activity_streak')}</p>
            <p className="text-3xl font-bold mt-1">
              {days} {t('dashboard.consecutive_days', { count: days })}
            </p>
          </div>
          <div className="text-5xl">🔥</div>
        </div>
      </CardContent>
    </Card>
  );
}

